import { strategyToOptions } from "@/common/utils/strategyToOptions"

export const branchType = {
  'Client::CompanyBranch': 'Empresa cliente',
  'Establishment::CompanyBranch': 'Estabelecimento',
}

export const branchTypeOptions = strategyToOptions(branchType);
